import AdminClient from '../client/AdminClient';

class CityService {
    static endpoint = '/v1/admin/cities';

    static async index(session, params) {
        return AdminClient.get(`${this.endpoint}`, session,
            {
                ...params,
            }
        );
    }

    static async new(session) {
        return AdminClient.get(`${this.endpoint}/new`, session);
    }

    static async create(session, city) {
        return AdminClient.post(`${this.endpoint}/`, session, {city: city});
    }

    static async update(cityId, session, city) {
        return AdminClient.put(`${this.endpoint}/${cityId}`, session, {city: city});
    }

    static async edit(cityId, session) {
        return AdminClient.get(`${this.endpoint}/${cityId}/edit`, session);
    }

    static async show(cityId, session) {
        return AdminClient.get(`${this.endpoint}/${cityId}`, session);
    }

    static async delete(cityId, session) {
        return AdminClient.delete(`${this.endpoint}/${cityId}`, session);
    }

    static async import(session, file) {
        const formData = new FormData();
        formData.append(`city[file]`, file || '');
        return AdminClient.post(`${this.endpoint}/import`, session, formData, true);
    }

    static async merge(cityId, session, cities) {
        return AdminClient.put(`${this.endpoint}/${cityId}/merge`, session, {city: {id: cityId, cities}});
    }

    static async search(query, session) {
        return AdminClient.get(`${this.endpoint}/search`, session, {query});
    }
}
export default CityService;